import * as api from '@gitbook/api-client';

import type { PermissionRoleGroup } from '../Organization';

/**
 * Role groups used when editing site-level user and team permissions.
 */
export const SITE_PERMISSION_ROLE_GROUPS: PermissionRoleGroup[] = [
    {
        key: 'site.can-manage',
        title: 'Can manage this site',
        roles: [api.MemberRole.Admin],
    },
    {
        key: 'site.can-create',
        title: 'Can create site content',
        roles: [api.MemberRole.Create],
    },
    {
        key: 'site.can-edit',
        title: 'Can edit site content',
        roles: [api.MemberRole.Review, api.MemberRole.Edit],
    },
    {
        key: 'site.can-see',
        title: 'Can see this site',
        roles: [api.MemberRole.Comment, api.MemberRole.Read],
    },
    {
        key: 'site.cannot-see',
        title: 'Cannot see this site',
        roles: [null],
    },
];
